import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-form';
import { isEmpty } from 'lodash';

import {
    Input,
    Select,
} from '../../Form';
import { createReactFormValidator, required, url } from '../../../utils/validation';
import { supportedEventAttachmentFileTypesAcceptsString } from '../../../utils/constants';
import { EventAttachmentMediaTypes } from '../../../utils/eventConstants';

import Popup from '../../Popup';

const _ = { isEmpty };

const AttachmentUploadPopup = (props) => {
    const {
        onCloseClick,
        onCtaClick,
        coreUI,
    } = props;

    const [submitting, setSubmitting] = useState(false);
    const [attachment, setAttachment] = useState(null);
    const [attachmentTouched, setAttachmentTouched] = useState(false);
    const [attachmentMediaTypeSelected, setAttachmentMediaTypeSelected] = useState(false);

    const titleDefaultValues = {
        fact_sheet: 'Fact Sheet',
        order_of_play: 'Order Of Play',
        other: 'My Attachment',
    };

    const defaultValues = {
        mediaType: '',
        url: '',
        type: 'fact_sheet',
        title: titleDefaultValues.fact_sheet,
    };
    const handleSubmit = async ({ values }) => {
        const formData = new FormData();
        formData.append('mediaType', values.mediaType);
        formData.append('type', values.type);
        formData.append('title', values.title);
        if (values.mediaType === EventAttachmentMediaTypes.LINK) {
            formData.append('url', values.url);
        } else if (values.mediaType === EventAttachmentMediaTypes.FILE) {
            formData.append('file', attachment);
        }
        setSubmitting(true);
        await onCtaClick(formData);
        setSubmitting(false);
        onCloseClick();
    };

    return (
        <Popup
            className={`popup-md`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: true,
                style: {
                    height: 580,
                    maxHeight: '100%',
                },
                scrollable: true,
            }}
        >
            <Form onSubmit={values => handleSubmit({ values })} defaultValues={defaultValues}>
                {(formApi) => {
                    const { submitForm, setValue, values } = formApi;
                    return (
                        <form onSubmit={submitForm} id="uploadEventAttachmentForm" data-test="uploadEventAttachmentForm">
                            <Select
                                id="mediaType"
                                field="mediaType"
                                attributeToSave="value"
                                options={coreUI.types.tms.eventAttachmentMediaTypes}
                                label="What type of attachment would you like to add?"
                                validate={required}
                                onChange={(value) => {
                                    if (!_.isEmpty(value)) {
                                        setAttachmentMediaTypeSelected(true);
                                    } else {
                                        setAttachmentMediaTypeSelected(false);
                                    }
                                }}
                            />
                            {attachmentMediaTypeSelected && (
                                <>
                                    <Select
                                        id="type"
                                        field="type"
                                        attributeToSave="value"
                                        options={coreUI.types.tms.eventAttachmentTypes}
                                        label="What Type of Attachment"
                                        validate={required}
                                        hiddenDefault={true}
                                        onChange={(value) => {
                                            setValue('title', titleDefaultValues[value]);
                                        }}
                                    />
                                    <Input
                                        label="Title"
                                        id="title"
                                        field="title"
                                        validate={required}
                                    />
                                    {values.mediaType === EventAttachmentMediaTypes.LINK && (
                                        <Input
                                            label="URL"
                                            id="url"
                                            field="url"
                                            placeholder="https://example.com"
                                            type="text"
                                            validate={createReactFormValidator([required, url])}
                                        />
                                    )}
                                    {values.mediaType === EventAttachmentMediaTypes.FILE && (
                                        <>
                                            <label className="btn btn-primary btn-xl text-uppercase btn-block mt20">
                                                Select File
                                                {' '}
                                                <input
                                                    type="file"
                                                    id="fileElem"
                                                    accept={supportedEventAttachmentFileTypesAcceptsString}
                                                    style={{ display: 'none' }}
                                                    required
                                                    onChange={(ev) => {
                                                        const attachmentFile = ev.target.files[0];
                                                        setAttachment(attachmentFile);
                                                        setAttachmentTouched(true);
                                                    }}
                                                />
                                            </label>
                                            {attachmentTouched && attachment && (
                                                <div>{attachment.name}</div>
                                            )}
                                            {attachmentTouched && !attachment && (
                                                <div className="invalid-feedback d-block">Please select a file.</div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            <hr />
                            <div className="row">
                                <div className="col-12 col-md-6 mb16">
                                    <button
                                        onClick={onCloseClick}
                                        type="button"
                                        className="btn btn-default btn-xl text-uppercase btn-block"
                                        disabled={submitting}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="col-12 col-md-6">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-xl text-uppercase btn-block"
                                        disabled={submitting}
                                        onClick={() => setAttachmentTouched(true)}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </Popup>
    );
};

function mapStateToProps({ coreUI }) {
    return { coreUI };
}

export default connect(mapStateToProps)(AttachmentUploadPopup);
